import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4b9dab4b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-hidden", "inert"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "aide-backdrop",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = { class: "aide-panel__close-anchor" }
const _hoisted_5 = ["title", "aria-label"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "aide-panel__close-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7 7L17 17M17 7L7 17",
    stroke: "currentColor",
    "stroke-width": "2.5",
    "stroke-linecap": "round"
  })
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "aide-panel__close-line",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_9 = { class: "aide-panel__body" }
const _hoisted_10 = ["src", "title"]

import { computed, nextTick, onBeforeUnmount, ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useAideDrawerStore } from '@/stores/aide-drawer.store'
import { AideBridgeService, resolveAideBridgeData } from '@/services/aide-bridge.service'
import { onAppThemeChange } from '@/utils/app-theme'
import { onDashboardNavThemeChange } from '@/utils/dashboard-nav-theme'
import { i18n } from '@/i18n'

const DRAWER_WIDTH_PX = 1200


export default /*#__PURE__*/_defineComponent({
  __name: 'aide-drawer',
  setup(__props) {

const store = useAideDrawerStore()
const { visible, iframeSrc, iframeEpoch } = storeToRefs(store)
const panelWidth = computed(() => `min(${DRAWER_WIDTH_PX}px, 92vw)`)
/** 收起动画结束前保持高层级，避免滑出过程被页面挡住 */
const raised = ref(false)

const iframeRef = ref<HTMLIFrameElement | null>(null)
let aideBridgeService: AideBridgeService | null = null
let unsubscribeNavTheme: (() => void) | null = null
let unsubscribeAppTheme: (() => void) | null = null

function disposeAideBridgeService () {
  unsubscribeNavTheme?.()
  unsubscribeNavTheme = null
  unsubscribeAppTheme?.()
  unsubscribeAppTheme = null
  aideBridgeService?.dispose()
  aideBridgeService = null
}

function ensureAideBridgeService () {
  disposeAideBridgeService()
  aideBridgeService = new AideBridgeService({
    getData: resolveAideBridgeData,
  })
  aideBridgeService.bindIframe(iframeRef.value)
  unsubscribeNavTheme = onDashboardNavThemeChange(() => {
    aideBridgeService?.pushSync()
  })
  unsubscribeAppTheme = onAppThemeChange(() => {
    aideBridgeService?.pushSync()
  })
}

watch([iframeSrc, iframeEpoch], ([src]) => {
  if (!src) {
    disposeAideBridgeService()
    return
  }
  void nextTick(() => {
    ensureAideBridgeService()
  })
}, { immediate: true })

watch(visible, (open) => {
  if (open) {
    raised.value = true
    // 入口点击时已刷新过权限。同步有效期，并让助手检查实例是否仍在运行
    aideBridgeService?.pushSync({ checkInstances: true })
  }
})

function onPanelTransitionEnd (event: TransitionEvent) {
  if (event.propertyName !== 'transform') return
  if (!visible.value) raised.value = false
}

watch(() => i18n.global.locale.value, () => {
  aideBridgeService?.pushSync()
})

onBeforeUnmount(() => {
  disposeAideBridgeService()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_unref(iframeSrc))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["aide-root", { 'is-open': _unref(visible), 'is-raised': _unref(visible) || raised.value }]),
          "aria-hidden": !_unref(visible),
          inert: !_unref(visible),
          onWheel: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
          onTouchmove: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _hoisted_2,
          _createElementVNode("aside", {
            class: "aide-panel",
            style: _normalizeStyle({ width: panelWidth.value }),
            role: "dialog",
            "aria-label": _ctx.$t('aide.title'),
            onTransitionend: onPanelTransitionEnd
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                type: "button",
                class: "aide-panel__close",
                title: _ctx.$t('aide.close'),
                "aria-label": _ctx.$t('aide.close'),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).close()))
              }, _hoisted_7, 8, _hoisted_5),
              _hoisted_8
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(), _createElementBlock("iframe", {
                key: _unref(iframeEpoch),
                ref_key: "iframeRef",
                ref: iframeRef,
                class: "aide-panel__iframe",
                src: _unref(iframeSrc),
                title: _ctx.$t('aide.title'),
                allow: "clipboard-read; clipboard-write"
              }, null, 8, _hoisted_10))
            ])
          ], 44, _hoisted_3)
        ], 42, _hoisted_1))
      : _createCommentVNode("", true)
  ]))
}
}

})